var AttributedString, DateTime, Item, ItemPath, Mutation, _, assert, ctphHash, stringHash;

AttributedString = require('./attributed-string');

stringHash = require('string-hash');

DateTime = require('./date-time');

ItemPath = require('./item-path');

Mutation = require('./mutation');

_ = require('underscore-plus');

assert = require('./util').assert;

ctphHash = require('ctph.js');

module.exports = Item = (function() {
  function Item(outline, text, id, remappedIDCallback) {
    this.id = outline.nextOutlineUniqueItemID(id);
    this.cachedBranchContentID = null;
    this.outline = outline;
    this.inOutline = false;
    this.recordedUndoableChanges = false;
    this.bodyHighlighted = null;
    if (text instanceof AttributedString) {
      this.body = text;
    } else {
      this.body = new AttributedString(text);
    }
    outline.itemDidChangeBody(this, '');
    if (id !== this.id) {
      if (remappedIDCallback && id) {
        remappedIDCallback(id, this.id, this);
      }
    }
  }


  /*
  Section: Properties
   */

  Item.prototype.id = null;

  Item.prototype.contentID = null;

  Object.defineProperty(Item.prototype, 'contentID', {
    get: function() {
      return stringHash(this.bodyString);
    }
  });

  Item.prototype.branchContentID = null;

  Object.defineProperty(Item.prototype, 'branchContentID', {
    get: function() {
      var childBranchContentIDs, each;
      if (!this.cachedBranchContentID) {
        childBranchContentIDs = [this.contentID];
        each = this.firstChild;
        while (each) {
          childBranchContentIDs.push(each.branchContentID);
          each = each.nextSibling;
        }
        this.cachedBranchContentID = "" + (stringHash(childBranchContentIDs.join('')));
      }
      return this.cachedBranchContentID;
    }
  });

  Item.prototype.clearCachedBranchContentID = function() {
    var each, results1;
    each = this;
    results1 = [];
    while (each) {
      each.cachedBranchContentID = null;
      results1.push(each = each.parent);
    }
    return results1;
  };

  Item.prototype.outline = null;


  /*
  Section: Clone
   */

  Item.prototype.clone = function(deep, remappedIDCallback) {
    return this.outline.cloneItem(this, deep, remappedIDCallback);
  };


  /*
  Section: Structure
   */

  Item.prototype.isInOutline = false;

  Object.defineProperty(Item.prototype, 'isInOutline', {
    get: function() {
      return this.inOutline;
    },
    set: function(isInOutline) {
      var each;
      if (this.inOutline !== isInOutline) {
        if (isInOutline) {
          this.recordedUndoableChanges = true;
          this.outline.idsToItems.set(this.id, this);
        } else {
          this.outline.idsToItems["delete"](this.id);
        }
        this.inOutline = isInOutline;
        each = this.firstChild;
        while (each) {
          each.isInOutline = isInOutline;
          each = each.nextSibling;
        }
      }
      return this;
    }
  });

  Item.prototype.isOutlineRoot = null;

  Object.defineProperty(Item.prototype, 'isOutlineRoot', {
    get: function() {
      return this === this.outline.root;
    }
  });

  Item.prototype.localRoot = null;

  Object.defineProperty(Item.prototype, 'localRoot', {
    get: function() {
      var each;
      if (this.isInOutline) {
        return this.outline.root;
      } else {
        each = this;
        while (each.parent) {
          each = each.parent;
        }
        return each;
      }
    }
  });

  Item.prototype.depth = null;

  Object.defineProperty(Item.prototype, 'depth', {
    get: function() {
      var ancestor, depth;
      depth = this.indent;
      ancestor = this.parent;
      while (ancestor) {
        depth += ancestor.indent;
        ancestor = ancestor.parent;
      }
      return depth;
    }
  });

  Item.prototype.row = null;

  Object.defineProperty(Item.prototype, 'row', {
    get: function() {
      var each, row;
      if (this.isOutlineRoot) {
        return -1;
      }
      row = 0;
      each = this.previousItem;
      while (each) {
        row++;
        each = each.previousItem;
      }
      return row;
    }
  });

  Item.prototype.parent = null;

  Item.prototype.firstChild = null;

  Item.prototype.lastChild = null;

  Item.prototype.previousSibling = null;

  Item.prototype.nextSibling = null;

  Item.prototype.previousBranch = null;

  Object.defineProperty(Item.prototype, 'previousBranch', {
    get: function() {
      return this.previousSibling || this.previousItem;
    }
  });

  Item.prototype.nextBranch = null;

  Object.defineProperty(Item.prototype, 'nextBranch', {
    get: function() {
      return this.lastBranchItem.nextItem;
    }
  });

  Item.prototype.ancestors = null;

  Object.defineProperty(Item.prototype, 'ancestors', {
    get: function() {
      var ancestors, each;
      ancestors = [];
      each = this.parent;
      while (each) {
        ancestors.unshift(each);
        each = each.parent;
      }
      return ancestors;
    }
  });

  Item.prototype.descendants = null;

  Object.defineProperty(Item.prototype, 'descendants', {
    get: function() {
      var descendants, each, end;
      descendants = [];
      end = this.nextBranch;
      each = this.nextItem;
      while (each !== end) {
        descendants.push(each);
        each = each.nextItem;
      }
      return descendants;
    }
  });

  Item.prototype.lastDescendant = null;

  Object.defineProperty(Item.prototype, 'lastDescendant', {
    get: function() {
      var each;
      each = this.lastChild;
      while (each != null ? each.lastChild : void 0) {
        each = each.lastChild;
      }
      return each;
    }
  });

  Item.prototype.branchItems = null;

  Object.defineProperty(Item.prototype, 'branchItems', {
    get: function() {
      var descendants;
      descendants = this.descendants;
      descendants.unshift(this);
      return descendants;
    }
  });

  Item.prototype.lastBranchItem = null;

  Object.defineProperty(Item.prototype, 'lastBranchItem', {
    get: function() {
      return this.lastDescendant || this;
    }
  });

  Item.prototype.previousItem = null;

  Object.defineProperty(Item.prototype, 'previousItem', {
    get: function() {
      var parent, previousSibling;
      previousSibling = this.previousSibling;
      if (previousSibling) {
        return previousSibling.lastBranchItem;
      } else {
        parent = this.parent;
        if (!parent || parent.isOutlineRoot) {
          return null;
        } else {
          return parent;
        }
      }
    }
  });

  Object.defineProperty(Item.prototype, 'previousItemOrRoot', {
    get: function() {
      return this.previousItem || this.parent;
    }
  });

  Item.prototype.nextItem = null;

  Object.defineProperty(Item.prototype, 'nextItem', {
    get: function() {
      var firstChild, nextSibling, parent;
      firstChild = this.firstChild;
      if (firstChild) {
        return firstChild;
      }
      nextSibling = this.nextSibling;
      if (nextSibling) {
        return nextSibling;
      }
      parent = this.parent;
      while (parent) {
        nextSibling = parent.nextSibling;
        if (nextSibling) {
          return nextSibling;
        }
        parent = parent.parent;
      }
      return null;
    }
  });

  Item.prototype.hasChildren = null;

  Object.defineProperty(Item.prototype, 'hasChildren', {
    get: function() {
      return !!this.firstChild;
    }
  });

  Item.prototype.children = null;

  Object.defineProperty(Item.prototype, 'children', {
    get: function() {
      var children, each;
      children = [];
      each = this.firstChild;
      while (each) {
        children.push(each);
        each = each.nextSibling;
      }
      return children;
    }
  });

  Item.prototype.contains = function(item) {
    var ancestor;
    ancestor = item != null ? item.parent : void 0;
    while (ancestor) {
      if (ancestor === this) {
        return true;
      }
      ancestor = ancestor.parent;
    }
    return false;
  };

  Item.getCommonAncestors = function(items) {
    var commonAncestors, each, itemIDs, j, k, len, len1, p;
    commonAncestors = [];
    itemIDs = {};
    for (j = 0, len = items.length; j < len; j++) {
      each = items[j];
      itemIDs[each.id] = true;
    }
    for (k = 0, len1 = items.length; k < len1; k++) {
      each = items[k];
      p = each.parent;
      while (p && !itemIDs[p.id]) {
        p = p.parent;
      }
      if (!p) {
        commonAncestors.push(each);
      }
    }
    return commonAncestors;
  };

  Item.buildItemHiearchy = function(items, parentStack) {
    var each, eachDepth, insertSiblings, j, len, newGroup, parent, roots, siblings, siblingsStack;
    if (parentStack == null) {
      parentStack = [];
    }
    Item.removeItemsFromParents(items);
    roots = [];
    siblingsStack = [];
    insertSiblings = function(siblings) {
      var each, j, len, parentDepth, siblingsDepth, siblingsIndent;
      if (siblings.parent) {
        parentDepth = siblings.parent.depth;
        siblingsDepth = siblings.depth;
        siblingsIndent = siblingsDepth - parentDepth;
        for (j = 0, len = siblings.length; j < len; j++) {
          each = siblings[j];
          each.indent = siblingsIndent;
        }
        return siblings.parent.insertChildrenBefore(siblings, null, true);
      } else {
        return roots = roots.concat(siblings);
      }
    };
    for (j = 0, len = items.length; j < len; j++) {
      each = items[j];
      eachDepth = each.depth;
      while ((siblings = siblingsStack[siblingsStack.length - 1]) && siblings.depth > eachDepth) {
        insertSiblings(siblings);
        siblingsStack.pop();
      }
      if (siblings && siblings.depth === eachDepth) {
        siblings.push(each);
      } else {
        while ((parent = parentStack[parentStack.length - 1]) && parent.depth >= eachDepth) {
          parentStack.pop();
        }
        newGroup = [each];
        newGroup.parent = parent;
        newGroup.depth = eachDepth;
        siblingsStack.push(newGroup);
      }
      parentStack.push(each);
    }
    while (siblingsStack.length) {
      siblings = siblingsStack[siblingsStack.length - 1];
      insertSiblings(siblings);
      siblingsStack.pop();
    }
    return roots;
  };

  Item.flattenItemHiearchy = function(items, removeFromParents) {
    var each, eachDescendant, flattenedItems, j, k, len, len1, ref;
    if (removeFromParents == null) {
      removeFromParents = true;
    }
    flattenedItems = [];
    for (j = 0, len = items.length; j < len; j++) {
      each = items[j];
      flattenedItems.push(each);
      if (each.hasChildren) {
        ref = each.descendants;
        for (k = 0, len1 = ref.length; k < len1; k++) {
          eachDescendant = ref[k];
          flattenedItems.push(eachDescendant);
        }
      }
    }
    if (removeFromParents) {
      this.removeItemsFromParents(flattenedItems);
    }
    return flattenedItems;
  };

  Item.removeItemsFromParents = function(items) {
    var each, j, len, previous, ref, ref1, siblings;
    siblings = [];
    previous = null;
    for (j = 0, len = items.length; j < len; j++) {
      each = items[j];
      if (each.parent != null) {
        if (!previous || previous.nextSibling === each) {
          siblings.push(each);
        } else {
          if ((ref = siblings[0].parent) != null) {
            ref.removeChildren(siblings);
          }
          siblings = [each];
        }
        previous = each;
      }
    }
    if (siblings.length) {
      return (ref1 = siblings[0].parent) != null ? ref1.removeChildren(siblings) : void 0;
    }
  };

  Item.itemsWithAncestors = function(items) {
    var addedIDs, ancestorsAndItems, each, index, j, len;
    ancestorsAndItems = [];
    addedIDs = {};
    for (j = 0, len = items.length; j < len; j++) {
      each = items[j];
      index = ancestorsAndItems.length;
      while (each) {
        if (addedIDs[each.id]) {
          continue;
        } else {
          ancestorsAndItems.splice(index, 0, each);
          addedIDs[each.id] = true;
        }
        each = each.parent;
      }
    }
    return ancestorsAndItems;
  };


  /*
  Section: Mutate Structure
   */

  Item.prototype.indent = null;

  Object.defineProperty(Item.prototype, 'indent', {
    get: function() {
      var indent;
      if (indent = this.getAttribute('indent')) {
        return parseInt(indent, 10);
      } else if (this.parent) {
        return 1;
      } else {
        return 0;
      }
    },
    set: function(indent) {
      var nextSibling, previousSibling;
      if (indent < 1) {
        indent = 1;
      }
      if (previousSibling = this.previousSibling) {
        assert(indent <= previousSibling.indent, 'item indent must be less then or equal to previousSibling indent');
      }
      if (nextSibling = this.nextSibling) {
        assert(indent >= nextSibling.indent, 'item indent must be greater then or equal to nextSibling indent');
      }
      if (this.parent && indent === 1) {
        indent = null;
      } else if (indent < 1) {
        indent = null;
      }
      return this.setAttribute('indent', indent);
    }
  });

  Item.prototype.insertChildrenBefore = function(children, referenceSibling, maintainIndentHack) {
    var childIndent, each, firstChild, i, isInOutline, j, k, l, lastChild, len, len1, mutation, outline, previousSibling, recordedUndoableChanges, ref, ref1;
    if (maintainIndentHack == null) {
      maintainIndentHack = false;
    }
    if (!Array.isArray(children)) {
      children = [children];
    }
    if (!children.length) {
      return;
    }
    recordedUndoableChanges = this.recordedUndoableChanges;
    isInOutline = this.isInOutline;
    outline = this.outline;
    if (isInOutline) {
      outline.beginChanges();
    }
    if (recordedUndoableChanges) {
      outline.undoManager.beginUndoGrouping();
    }
    Item.removeItemsFromParents(children);
    if (referenceSibling) {
      assert(referenceSibling.parent === this, 'referenceSibling must be child of this item');
      previousSibling = referenceSibling.previousSibling;
    } else {
      previousSibling = this.lastChild;
    }
    if (isInOutline || recordedUndoableChanges) {
      mutation = Mutation.createChildrenMutation(this, children, [], previousSibling, referenceSibling);
      if (isInOutline) {
        outline.willChange(mutation);
      }
      outline.recordChange(mutation);
    }
    for (i = j = 0, len = children.length; j < len; i = ++j) {
      each = children[i];
      assert(each.parent !== this, 'insert items must not already be children');
      assert(each.outline === this.outline, 'children must share same outline as parent');
      each.previousSibling = children[i - 1];
      each.nextSibling = children[i + 1];
      each.parent = this;
    }
    firstChild = children[0];
    lastChild = children[children.length - 1];
    firstChild.previousSibling = previousSibling;
    if (previousSibling != null) {
      previousSibling.nextSibling = firstChild;
    }
    lastChild.nextSibling = referenceSibling;
    if (referenceSibling != null) {
      referenceSibling.previousSibling = lastChild;
    }
    if (!firstChild.previousSibling) {
      this.firstChild = firstChild;
    }
    if (!lastChild.nextSibling) {
      this.lastChild = lastChild;
    }
    if (!maintainIndentHack) {
      childIndent = (ref = (ref1 = previousSibling != null ? previousSibling.indent : void 0) != null ? ref1 : referenceSibling != null ? referenceSibling.indent : void 0) != null ? ref : 1;
      for (k = children.length - 1; k >= 0; k += -1) {
        each = children[k];
        each.indent = childIndent;
      }
    }
    if (recordedUndoableChanges) {
      outline.undoManager.endUndoGrouping();
    }
    this.clearCachedBranchContentID();
    if (isInOutline) {
      for (l = 0, len1 = children.length; l < len1; l++) {
        each = children[l];
        each.isInOutline = true;
      }
      outline.didChange(mutation);
      return outline.endChanges();
    }
  };

  Item.prototype.appendChildren = function(children) {
    return this.insertChildrenBefore(children, null);
  };

  Item.prototype.removeChildren = function(children) {
    var depth, each, eachIndent, firstChild, isInOutline, j, lastChild, len, mutation, nextSibling, outline, previousSibling, recordedUndoableChanges;
    if (!Array.isArray(children)) {
      children = [children];
    }
    if (!children.length) {
      return;
    }
    recordedUndoableChanges = this.recordedUndoableChanges;
    isInOutline = this.isInOutline;
    outline = this.outline;
    firstChild = children[0];
    lastChild = children[children.length - 1];
    previousSibling = firstChild.previousSibling;
    nextSibling = lastChild.nextSibling;
    if (isInOutline) {
      outline.beginChanges();
    }
    if (recordedUndoableChanges) {
      outline.undoManager.beginUndoGrouping();
    }
    if (isInOutline || recordedUndoableChanges) {
      mutation = Mutation.createChildrenMutation(this, [], children, previousSibling, nextSibling);
      if (isInOutline) {
        outline.willChange(mutation);
      }
      outline.recordChange(mutation);
    }
    if (previousSibling != null) {
      previousSibling.nextSibling = nextSibling;
    }
    if (nextSibling != null) {
      nextSibling.previousSibling = previousSibling;
    }
    if (firstChild === this.firstChild) {
      this.firstChild = nextSibling;
    }
    if (lastChild === this.lastChild) {
      this.lastChild = previousSibling;
    }
    depth = this.depth;
    for (j = 0, len = children.length; j < len; j++) {
      each = children[j];
      assert(each.parent === this, 'removed items must be children of this item');
      eachIndent = each.indent;
      each.isInOutline = false;
      each.nextSibling = null;
      each.previousSibling = null;
      each.parent = null;
      each.indent = eachIndent + depth;
    }
    if (recordedUndoableChanges) {
      outline.undoManager.endUndoGrouping();
    }
    this.clearCachedBranchContentID();
    if (isInOutline) {
      outline.didChange(mutation);
      return outline.endChanges();
    }
  };

  Item.prototype.removeFromParent = function() {
    var ref;
    return (ref = this.parent) != null ? ref.removeChildren(this) : void 0;
  };


  /*
  Section: Item Attributes
   */

  Item.prototype.tagName = null;

  Object.defineProperty(Item.prototype, 'tagName', {
    get: function() {
      return 'item';
    }
  });


  /*
  Not going to support nested elements for styling, makes invalidating to hard for now.
  parentNode: null
  Object.defineProperty @::, 'parentNode',
    get: -> @parent
   */

  Item.prototype.attributes = null;

  Item.prototype.attributeNames = null;

  Object.defineProperty(Item.prototype, 'attributeNames', {
    get: function() {
      if (this.attributes) {
        return Object.keys(this.attributes).sort();
      } else {
        return [];
      }
    }
  });

  Item.prototype.hasAttribute = function(name) {
    var ref;
    return ((ref = this.attributes) != null ? ref[name] : void 0) != null;
  };

  Item.prototype.getAttribute = function(name, clazz, array) {
    var each, ref, value;
    if (value = (ref = this.attributes) != null ? ref[name] : void 0) {
      if (array && (typeof value === 'string')) {
        value = value.split(/\s*,\s*/);
        if (clazz) {
          value = (function() {
            var j, len, results1;
            results1 = [];
            for (j = 0, len = value.length; j < len; j++) {
              each = value[j];
              results1.push(Item.attributeValueStringToObject(each, clazz));
            }
            return results1;
          })();
        }
      } else if (clazz && (typeof value === 'string')) {
        value = Item.attributeValueStringToObject(value, clazz);
      }
    }
    return value;
  };

  Item.prototype.setAttribute = function(name, value) {
    var isInOutline, mutation, oldValue, outline, recordedUndoableChanges, undoManager;
    assert(name !== 'id', 'id is reserved attribute name');
    if (value) {
      value = Item.objectToAttributeValueString(value);
    }
    oldValue = this.getAttribute(name);
    if (value === oldValue) {
      return;
    }
    outline = this.outline;
    undoManager = outline.undoManager;
    recordedUndoableChanges = this.recordedUndoableChanges;
    isInOutline = this.isInOutline;
    if (isInOutline) {
      outline.beginChanges();
    }
    if (isInOutline || recordedUndoableChanges) {
      mutation = Mutation.createAttributeMutation(this, name, oldValue);
      if (isInOutline) {
        outline.willChange(mutation);
      }
      outline.recordChange(mutation);
      undoManager.disableUndoRegistration();
    }
    if (value != null) {
      if (!this.attributes) {
        this.attributes = {};
      }
      this.attributes[name] = value;
    } else {
      if (this.attributes) {
        delete this.attributes[name];
      }
    }
    outline.itemDidChangeAttribute(this, name, value, oldValue);
    if (isInOutline) {
      outline.didChange(mutation);
      outline.endChanges();
    }
    if (isInOutline || recordedUndoableChanges) {
      return undoManager.enableUndoRegistration();
    }
  };

  Item.prototype.removeAttribute = function(name) {
    if (this.hasAttribute(name)) {
      return this.setAttribute(name, null);
    }
  };

  Item.attributeValueStringToObject = function(value, clazz) {
    var ref;
    switch (clazz) {
      case Number:
      case 'Number':
        return parseFloat(value);
      case Date:
      case 'Date':
        return (ref = DateTime.parse(value)) != null ? ref : '';
      default:
        return value;
    }
  };

  Item.objectToAttributeValueString = function(object) {
    var each;
    switch (typeof object) {
      case 'string':
        return object;
      case 'number':
        return object.toString();
      case 'object':
        return object.toString();
      default:
        if (object instanceof Date) {
          return object.toISOString();
        } else if (Array.isArray(object)) {
          return ((function() {
            var j, len, results1;
            results1 = [];
            for (j = 0, len = object.length; j < len; j++) {
              each = object[j];
              results1.push(Item.objectToAttributeValueString(each));
            }
            return results1;
          })()).join(',');
        } else if (object) {
          return object.toString();
        } else {
          return object;
        }
    }
  };


  /*
  Section: Item Body Text
   */

  Item.prototype.bodyString = null;

  Object.defineProperty(Item.prototype, 'bodyString', {
    get: function() {
      return this.body.string.toString();
    },
    set: function(text) {
      if (text == null) {
        text = '';
      }
      return this.replaceBodyRange(0, -1, text);
    }
  });

  Item.prototype.bodyContentString = null;

  Object.defineProperty(Item.prototype, 'bodyContentString', {
    get: function() {
      var range;
      range = {};
      if (this.bodyHighlightedAttributedString.getFirstOccuranceOfAttribute('content', null, range) != null) {
        return this.bodyString.substr(range.location, range.length);
      } else {
        return this.bodyString;
      }
    },
    set: function(text) {
      var range;
      if (text == null) {
        text = '';
      }
      range = {};
      if (this.bodyHighlightedAttributedString.getFirstOccuranceOfAttribute('content', null, range) != null) {
        return this.replaceBodyRange(range.location, range.length, text);
      } else {
        return this.bodyString = text;
      }
    }
  });

  Item.prototype.bodyHTMLString = null;

  Object.defineProperty(Item.prototype, 'bodyHTMLString', {
    get: function() {
      return this.bodyAttributedString.toInlineBMLString();
    },
    set: function(html) {
      return this.bodyAttributedString = AttributedString.fromInlineBMLString(html);
    }
  });

  Item.prototype.bodyAttributedString = null;

  Object.defineProperty(Item.prototype, 'bodyAttributedString', {
    get: function() {
      if (this.isOutlineRoot) {
        return new AttributedString;
      }
      return this.body;
    },
    set: function(attributedText) {
      return this.replaceBodyRange(0, -1, attributedText);
    }
  });

  Item.prototype.bodyHighlightedAttributedString = null;

  Object.defineProperty(Item.prototype, 'bodyHighlightedAttributedString', {
    get: function() {
      var ref;
      return (ref = this.bodyHighlighted) != null ? ref : this.body;
    }
  });

  Item.prototype.bodyAttributedSubstringFromRange = function(location, length) {
    return this.bodyAttributedString.attributedSubstringFromRange(location, length);
  };

  Item.prototype.getBodyAttributesAtIndex = function(characterIndex, effectiveRange, longestEffectiveRange) {
    return this.bodyAttributedString.getAttributesAtIndex(characterIndex, effectiveRange, longestEffectiveRange);
  };

  Item.prototype.getBodyAttributeAtIndex = function(attribute, characterIndex, effectiveRange, longestEffectiveRange) {
    return this.bodyAttributedString.getAttributeAtIndex(attribute, characterIndex, effectiveRange, longestEffectiveRange);
  };

  Item.prototype.setBodyAttributesInRange = function(attributes, location, length) {
    var changedText;
    this.bodyAttributedString.setAttributesInRange(attributes, location, length);
    changedText = this.bodyAttributedSubstringFromRange(location, length);
    changedText.setAttributesInRange(attributes, location, length);
    return this.replaceBodyRange(location, length, changedText);
  };

  Item.prototype.addBodyAttributeInRange = function(attribute, value, location, length) {
    var attributes;
    attributes = {};
    attributes[attribute] = value;
    return this.addBodyAttributesInRange(attributes, location, length);
  };

  Item.prototype.addBodyAttributesInRange = function(attributes, location, length) {
    var changedText, eachTagName;
    for (eachTagName in attributes) {
      assert(eachTagName === eachTagName.toLowerCase(), 'Tag Names Must be Lowercase');
    }
    changedText = this.bodyAttributedSubstringFromRange(location, length);
    changedText.addAttributesInRange(attributes, 0, length);
    return this.replaceBodyRange(location, length, changedText);
  };

  Item.prototype.removeBodyAttributeInRange = function(attribute, location, length) {
    return this.removeBodyAttributesInRange([attribute], location, length);
  };

  Item.prototype.removeBodyAttributesInRange = function(attributes, location, length) {
    var changedText, each, j, len;
    changedText = this.bodyAttributedSubstringFromRange(location, length);
    for (j = 0, len = attributes.length; j < len; j++) {
      each = attributes[j];
      changedText.removeAttributeInRange(each, 0, length);
    }
    return this.replaceBodyRange(location, length, changedText);
  };

  Item.prototype.insertLineBreakInBody = function(index) {};

  Item.prototype.insertImageInBody = function(index, image) {};

  Item.prototype.replaceBodyRange = function(location, length, insertedText) {
    var bodyAttributedString, insertedString, isInOutline, mutation, oldBody, outline, recordedUndoableChanges, replacedText, undoManager;
    if (this.isOutlineRoot) {
      return;
    }
    if (insertedText instanceof AttributedString) {
      insertedString = insertedText.string;
    } else {
      insertedString = insertedText;
    }
    if (length === 0 && insertedString.length === 0) {
      return;
    }
    bodyAttributedString = this.bodyAttributedString;
    oldBody = bodyAttributedString.getString();
    recordedUndoableChanges = this.recordedUndoableChanges;
    isInOutline = this.isInOutline;
    outline = this.outline;
    undoManager = outline.undoManager;
    assert(insertedString.indexOf('\n') === -1, 'Item body text cannot contain newlines');
    assert(location + length <= oldBody.length, 'Replace range end must not be greater then body text');
    if (isInOutline || recordedUndoableChanges) {
      replacedText = bodyAttributedString.attributedSubstringFromRange(location, length);
      if (replacedText.length === 0 && insertedText.length === 0) {
        return;
      }
      mutation = Mutation.createBodyMutation(this, location, insertedString.length, replacedText);
    }
    if (isInOutline) {
      outline.willChange(mutation);
      outline.beginChanges();
    }
    if (mutation) {
      outline.recordChange(mutation);
    }
    if (recordedUndoableChanges) {
      undoManager.disableUndoRegistration();
    }
    bodyAttributedString.replaceRange(location, length, insertedText);
    this.bodyHighlighted = null;
    outline.itemDidChangeBody(this, oldBody);
    this.clearCachedBranchContentID();
    if (isInOutline) {
      outline.didChange(mutation);
      outline.endChanges();
    }
    if (recordedUndoableChanges) {
      return undoManager.enableUndoRegistration();
    }
  };

  Item.prototype.appendBody = function(text) {
    return this.replaceBodyRange(this.bodyString.length, 0, text);
  };

  Item.prototype.addBodyHighlightAttributeInRange = function(attribute, value, index, length) {
    if (!this.bodyHighlighted) {
      this.bodyHighlighted = this.bodyAttributedString.clone();
    }
    return this.bodyHighlighted.addAttributeInRange(attribute, value, index, length);
  };

  Item.prototype.addBodyHighlightAttributesInRange = function(attributes, index, length) {
    if (!this.bodyHighlighted) {
      this.bodyHighlighted = this.bodyAttributedString.clone();
    }
    return this.bodyHighlighted.addAttributesInRange(attributes, index, length);
  };


  /*
  Section: Debug
   */

  Item.prototype.branchToString = function(depthString) {
    var each, indent, j, len, ref, results;
    if (depthString == null) {
      depthString = '';
    }
    indent = this.indent;
    while (indent) {
      depthString += '  ';
      indent--;
    }
    results = [this.toString(depthString)];
    ref = this.children;
    for (j = 0, len = ref.length; j < len; j++) {
      each = ref[j];
      results.push(each.branchToString(depthString));
    }
    return results.join('\n');
  };

  Item.prototype.toString = function(depthString) {
    return (depthString || '') + '(' + this.id + ') ' + this.body.toString();
  };

  return Item;

})();



/*****************
 ** WEBPACK FOOTER
 ** ./lib/item.js
 ** module id = 75
 ** module chunks = 0
 **/